export default "__VITE_ASSET__1037e4a2__"